import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFromLocalStorage } from './EncryptDecrypt.jsx';
import { ClipLoader } from "react-spinners";
import notify from './Nots.jsx';
import { domain } from './Domain.jsx';
import useApiRequest from './useApiRequest.jsx';

const LoginContext = createContext();

export const useLoginContext = () => {
  return useContext(LoginContext);
};

export const initial = {};

export const LoginProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(initial);
  const [loading, setLoading] = useState(true);
  const { postRequest, loading: postLoading } = useApiRequest()

  useEffect(() => {
    try {
      const storedUserInfo = getFromLocalStorage('authInfo');

      if (storedUserInfo) {
        setIsLoggedIn(true);
        setUserInfo(storedUserInfo);
      } else {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('authInfo');
      }

    } catch (error) {
      console.error("Error initializing login state:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleLogout = async () => {
    try {
      const token = getFromLocalStorage("authInfo");
      const response = await postRequest(`${domain}/accounts/logout`, {
        refresh: token?.refreshToken
      });

      console.log("Logout response:", response);

      if (response.status === 205) {
        notify("Logout successful", "success");
        localStorage.removeItem("authInfo");
        localStorage.removeItem("isLoggedIn");
        setUserInfo(initial)
        navigate('/login');
      } else {
        notify("Logout failed", "error");
      }
    } catch (err) {
      notify("Logout error occurred", "error");
      console.error("Logout error:", err);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <ClipLoader color="#3498db" size={50} />
      </div>
    );
  }

  return (
    <LoginContext.Provider value={{ isLoggedIn, setIsLoggedIn, userInfo, setUserInfo, handleLogout }}>
      {children}
    </LoginContext.Provider>
  );
};

export default LoginProvider;